import { IReduxAction } from '@gsk-tech/gsk-react-framework'
// import { API } from 'api/api'

export enum EActionType {
	//FETCH_AUTH_TOKEN = 'FETCH_AUTH_TOKEN',
	FETCH_TOKEN_ABORT = 'FETCH_AUTH_TOKEN_ABORT',
	FETCH_TOKEN_ERROR = 'FETCH_AUTH_TOKEN_ERROR',
	FETCH_TOKEN_SUCCESS = 'FETCH_AUTH_TOKEN_SUCCESS',
	FETCH_AUTH_TOKEN_SSO = 'FETCH_AUTH_TOKEN_SSO',
	SET_LOGGEDOUT = 'SET_LOGGEDOUT',
}

// Fetch token action
// export const fetchAuthTokenAction = (user: string, password: string): IReduxAction => ({
// 	meta: {
// 		asMutation: false,
// 		asPromise: true,
// 	},
// 	request: API.fetchAuthToken(user, password),
// 	type: EActionType.FETCH_AUTH_TOKEN,
// })

export const fetchAuthTokenSSOAction: IReduxAction = {
	meta: {
		asMutation: false,
		asPromise: true,
	},
	type: EActionType.FETCH_AUTH_TOKEN_SSO,
}

export const setLoggedOut: IReduxAction = {
	meta: {
		asMutation: false,
		asPromise: true,
	},
	type: EActionType.SET_LOGGEDOUT,
}
